// extracted by mini-css-extract-plugin
export default {"flex":"ResourcesCard_flex__u6BH+","row":"ResourcesCard_row__HknOv","mb30":"ResourcesCard_mb30__9SWjX","mb26":"ResourcesCard_mb26__4Q-et","mb20":"ResourcesCard_mb20__niUJR"};